import React, { useState } from "react";
import MyAppliances from "./MyAppliances";
import SolarCalculatorImg from "../../../Images/EssentialLoads/SOLAR CALCULATOR .jpg";
import JanicaRecommendation from "./JanicaRecommendation";
import SolarCalculatorFunctionalities from "../../utills/SolarCalculatorFunctionalities";
import SiteSurvey from "./SiteSurvey";

const SolarCalculator = () => {
  const {
    appliances,
    handleInputChange,
    handleAddAppliancesField,
    calculateSolarRecommendation,
    handleRemoveInputField,
    totalConsumption,
    recommendation,
    location,
  } = SolarCalculatorFunctionalities();
  return (
    <>
      <div className="bg-bgBlack relative min-h-screen">
        <div className="text-white gap-4 flex justify-center flex-col items-center sm:text-xl text-base pt-4">
          <h1>Let's start your power planning</h1>
          <img
            src={SolarCalculatorImg}
            alt="SolarCalculatorImg"
            className=" sm:w-72 w-60"
          />
        </div>

        <div className="bg-lightBlack text-white sm:p-5 p-1 max-w-2xl mx-auto mt-10  ">
          <div className="flex flex-row ">
            <div className="flex border-b w-full ">
              <button
                className={`flex-1 py-2 font-bold bg-error text-white
                    
                `}
              >
                I Know My Appliances
              </button>
            </div>
          </div>
          <MyAppliances
            appliances={appliances}
            handleInputChange={handleInputChange}
            handleAddAppliancesField={handleAddAppliancesField}
            calculateSolarRecommendation={calculateSolarRecommendation}
            handleRemoveInputField={handleRemoveInputField}
            location={location}
          />
        </div>

        <JanicaRecommendation
          totalConsumption={totalConsumption}
          recommendation={recommendation}
        />
        <SiteSurvey />
      </div>
    </>
  );
};

export default SolarCalculator;
